import React, { useEffect, useMemo, useState } from 'react';
import { HashRouter as Router, useLocation, Route, Switch, Redirect } from 'react-router-dom';
import globals from '../services/globals';
import Dashboard from '../components/dashboard/Dashboard';
import helper from "../services/helper";
import loginService from '../services/loginService';
import config from '../config/config';
import apiService from "../services/apiServices";


export default function App() {

    const [user, setUser] = useState();
    const [company, setCompany] = useState("");

    const setUserCompany = (user) => {
        //save login infos on cookie if user clicked rememberMe for 4 days 
        var jsValue = JSON.stringify(user);
        let rememberMe = helper().getItem('rememberMe');
        let exdays = (rememberMe) ? 4 : 0;
        helper().setItem("logedInUser", jsValue, exdays);

        globals().getSettings();
        globals().getUserSettings(user, true).then(() => {
            window.location = config.homepage;
        });
    }

    useEffect(() => {
        //debugger
        var user = globals().getLogedInUser();

        if (user) {
            setUser(user);
            if (user.company) {
                setCompany(user.company);
                globals().getSettings();
                globals().getUserSettings(user);
            }
        }
        else {
            //debugger
            var authCode = helper().getParameterByName('authcode');
            var rememberMe = helper().getParameterByName('rememberme');

            if (rememberMe) {
                helper().setItem('rememberMe', rememberMe);
            }

            if (authCode) {
                loginService().useAuthCode(authCode).then(function (user) {
                    console.log(user)
                    if (user.success) {
                        apiService().getDatabases("getUserDatabases?username=" + user.data.username).then((response) => {
                            if (response.success) {
                                response.data = response.data.filter(e => e.ServicePlanId === 2)
                                if (response.data.length === 1) {
                                    user.company = response.data[0].Name;
                                    user.subscription = response.data[0].Id;
                                    setUserCompany(user);
                                }
                                else {
                                    setUserCompany(user);
                                }
                            }
                        });
                    }
                });
            } else {
                var currentLocation = window.location;
                window.location = config.loginUrl + '?redirectUrl=' + currentLocation;
            }
        }
    }, []);
    return (
        <Router>
            <Switch>
                {/* {user ? <Route path="/" component={Body} /> : null} */}
                {user ? <Route path="/" component={Dashboard} /> : null}
            </Switch>
        </Router>
    )
}



